<template>
  <li v-if="show">
    <div
      class="d-flex align-items-center gap-1 rounded px-1 small user-select-none p-2"
      :class="{ 'node-btn': !node.leaf && !visibleIds, 'fw-semibold': isMatch }"
      @click="toggle"
    >
      <span class="flex-shrink-0 text-secondary" style="width: 1em">
        <i v-if="node.children.length" :class="expanded ? 'bi bi-chevron-down' : 'bi bi-chevron-right'" />
      </span>
      <span class="flex-fill" v-html="highlightedName" />
      <span v-if="node.children.length" class="ms-1 text-muted">{{ node.children.length }}</span>
    </div>
    <ul v-if="expanded && node.children.length" class="list-unstyled ps-3 mb-0">
      <CategoryTreeNode
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :visible-ids="visibleIds"
        :search="search"
      />
    </ul>
  </li>
</template>

<script setup>
import { ref, computed, defineOptions, defineProps } from 'vue'

defineOptions({ name: 'CategoryTreeNode' })

const props = defineProps({
  node: { type: Object, required: true },
  visibleIds: { type: Object, default: null },
  search: { type: String, default: '' },
})

const userExpanded = ref(false)

const show = computed(() => {
  if (!props.visibleIds) return true
  return props.visibleIds.has(props.node.id)
})

const expanded = computed(() => {
  if (props.visibleIds) {
    return props.node.children.some(c => props.visibleIds.has(c.id))
  }
  return userExpanded.value
})

const isMatch = computed(() =>
  props.visibleIds !== null && props.search && props.node.name.toLowerCase().includes(props.search.toLowerCase())
)

const highlightedName = computed(() => {
  if (!props.search || !isMatch.value) return props.node.name
  const term = props.search
  const idx = props.node.name.toLowerCase().indexOf(term.toLowerCase())
  if (idx === -1) return props.node.name
  return (
    props.node.name.slice(0, idx) +
    '<mark>' + props.node.name.slice(idx, idx + term.length) + '</mark>' +
    props.node.name.slice(idx + term.length)
  )
})

function toggle() {
  if (!props.visibleIds && props.node.children.length) {
    userExpanded.value = !userExpanded.value
  }
}
</script>

<style lang="scss" scoped>
.node-btn {
  cursor: pointer;
  &:hover { background-color: rgba(0, 0, 0, 0.05); }
}
</style>
